module.exports = __webpack_public_path__ + "img/尾部bg.43bd35cb.png";